<template>
  <div
    class="input-box-holder"
    v-validate="errors"
  >
    <div
      class="rating flex f-center"
      @mouseleave="hoverStar = -1"
    >
      <div class="stars f-center mr-children-1 mr-1">
        <div
          class="star"
          v-for="star in 5"
          :key="star"
          @mouseenter="mouseenter(star)"
          @click="emit"
        >
          <i class="icon icon--star-empty"></i>
          <i
            class="absolute up icon icon--star-fill"
            v-show="(hoverStar !== -1 && star <= hoverStar) || (hoverStar === -1 && star <= value)"
          ></i>
        </div>
      </div>
      <div class="stars-summary">
        <p>
          <strong class="font-black font-medium">{{totalStars}}</strong>
          <span class="font-small">/5</span>
        </p>
      </div>
    </div>

    <div class="validation-output">
      <slot name="validations"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Stars',
  props: ['value', 'errors', 'disable'],
  data() {
    return {
      hoverStar: -1,
    };
  },
  computed: {
    totalStars() {
      if (this.hoverStar !== -1) return this.hoverStar;
      return this.value;
    },
  },
  methods: {
    emit() {
      if (!this.disable) {
        this.$emit('input', this.hoverStar);
      }
    },
    mouseenter(star) {
      if (!this.disable) {
        this.hoverStar = star;
      }
    },
  },
};
</script>
